import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbMenuItem, NbMenuService } from '@nebular/theme';
import { ConfigurationService } from '@urbannex/configuration';
import { BaseComponentConfig, ComponentConfig, UpdateComponentStoreService, ViewContainersService } from '@urbannex/view-containers';
import { take } from 'rxjs';

@Component({
  selector: 'ngx-customer',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.scss']
})
export class CustomerComponent extends BaseComponentConfig implements OnInit{
  partyId:string;

  @Output() contextMenuItems = new EventEmitter<NbMenuItem[]>()

  constructor(viewContainerService:ViewContainersService,
    menuService:NbMenuService,
    route:ActivatedRoute,
    router:Router,
    updateComponentStoreService:UpdateComponentStoreService,
    configurationService:ConfigurationService) { 
    super(viewContainerService,menuService,configurationService,route,router,updateComponentStoreService)
    //this.componentConfig = new ComponentConfig(this.options);
    //console.log("WebSiteComponent",this.componentConfig)
    }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      if(params.get("partyId")){
        this.partyId = params.get("partyId");
        let menuItems:NbMenuItem[] = [
          {
            title:"Customer ["+this.partyId+"]",
            group:true,
          },
          {
            "title":"Orders",
            "link":'/admin/crm/customers/customer/'+this.partyId+'/orders'            
          },
          {
            "title":"Requests",
            "link":'/admin/crm/customers/customer/'+this.partyId+'/requests'            
          },
          {
            "title":"Quotes",
            "link":'/admin/crm/customers/customer/'+this.partyId+'/quotes'            
          },
          {
            "title":"Communications",
            "link":'/admin/crm/customers/customer/'+this.partyId+'/communications'            
          },
          {
            "title":"Shopping Lists",
            "link":'/admin/crm/customers/customer/'+this.partyId+'/shoppinglists'            
          },
          {
            "title":"Contact Lists",
            "link":'/admin/crm/customers/customer/'+this.partyId+'/contactLists'            
          }
        ]
        console.log("Adding menu items")
        //this.viewContainerService.contextMenu$.next(menuItems);
        //this.menuService.addItems(menuItems,'contextMenu');
        this.contextMenuItems.emit(menuItems);
      }
    })
  }
}  

